import { render, staticRenderFns } from "./PageSliderPopup.vue?vue&type=template&id=15785a20&"
import script from "./PageSliderPopup.vue?vue&type=script&lang=js&"
export * from "./PageSliderPopup.vue?vue&type=script&lang=js&"
import style0 from "./PageSliderPopup.vue?vue&type=style&index=0&id=15785a20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports